import React from "react";

import {rolePosition} from "@/utils/scoutingData";

import "./index.scss";

const W = 100,
	H = 150;

// Mini campo verticale con il ruolo principale (pieno) e gli alternativi (vuoti).
const PositionsPitch = (props) => {
	const {primary, alternatives = []} = props;
	const roles = [
		{role: primary, primary: true},
		...alternatives.map((role) => ({role, primary: false})),
	]
		.map((r) => ({...r, position: rolePosition(r.role)}))
		.filter((r) => r.role && r.position);

	return (
		<div className="positions-pitch">
			<svg
				viewBox={`0 0 ${W} ${H}`}
				role="img"
				aria-label={
					roles.length
						? "Posizioni: " + roles.map((r) => r.role).join(", ")
						: "Posizione non indicata"
				}
			>
				<rect className="positions-pitch__grass" width={W} height={H} rx="3" />
				<g className="positions-pitch__lines">
					<rect x="4" y="4" width={W - 8} height={H - 8} />
					<line x1="4" y1={H / 2} x2={W - 4} y2={H / 2} />
					<circle cx={W / 2} cy={H / 2} r="11" />
					<rect x="24" y="4" width="52" height="22" />
					<rect x="24" y={H - 26} width="52" height="22" />
					<rect x="38" y="4" width="24" height="8" />
					<rect x="38" y={H - 12} width="24" height="8" />
				</g>
				{roles.map(({role, primary: isPrimary, position}) => (
					<circle
						key={role}
						className={
							"positions-pitch__dot" +
							(isPrimary ? " positions-pitch__dot--primary" : "")
						}
						cx={(position.x / 100) * W}
						cy={(position.y / 100) * H}
						r={isPrimary ? 6 : 5}
					/>
				))}
			</svg>
			<div className="positions-pitch__legend">
				{roles.length ? (
					roles.map(({role, primary: isPrimary}) => (
						<div key={role} className="positions-pitch__role">
							<span
								className={
									"positions-pitch__marker" +
									(isPrimary ? " positions-pitch__marker--primary" : "")
								}
							/>
							<span>{role}</span>
							{isPrimary && (
								<span className="positions-pitch__hint">principale</span>
							)}
						</div>
					))
				) : (
					<div className="positions-pitch__empty">Ruolo non indicato</div>
				)}
			</div>
		</div>
	);
};

export default PositionsPitch;
